// src/components/ProjectList.jsx
import React from 'react';

const ProjectList = () => {
  const projects = [
     {
      title: "UREKA SHIFT",
      timeframe: "2024-2027",
      grant: "€6.5M",
      funding: "Erasmus+",
      reference: "101124308",
      role: "Researcher/WP Task Leader",
      objective: "At U!REKA, we empower future generations through cross-border collaboration in higher education. By uniting diverse expertise across Europe, we educate inclusive, forward-thinking professionals equipped to lead the transition to climate-neutral, smart, and sustainable cities."
    }
  ];

  return (
    <section>
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">Research Projects (ongoing)</h2>
      <ol className="list-decimal pl-5 space-y-2">
        {projects.map((project, index) => (
          <li key={index} className="text-gray-600 dark:text-gray-300">
            <div className="space-y-1 text-sm md:text-base">
              <h4 className="text-gray-900 dark:text-white">
              {project.timeframe}: <span className="font-semibold">{project.title}</span> 
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
              <div className="flex items-start">
                  <span className="font-medium mr-2">Reference:</span>
                  <span>{project.reference}</span>
                </div>
                
                <div className="flex items-start">
                  <span className="font-medium mr-2">Role:</span>
                  <span>{project.role}</span>
                </div>
                <div className="flex items-start">
                  <span className="font-medium mr-2">Funding:</span>
                  <span>{project.grant}</span>
                </div>
                <div className="flex items-start">
                  <span className="font-medium mr-2">Agency:</span>
                  <span>{project.funding}</span>
                </div>
              </div>
              <div>
                <span className="font-medium mt-1">Objective: </span>
                <span>{project.objective}</span>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default ProjectList;